import type { RunDeviceMarks } from "./types";

/**
 * Every device on the run, at the end of its own cable.
 *
 * The whole run and not the one device that just joined it: the device alone
 * says only that it moved, and what he asked for is *where it went* — *"blink
 * the new route with that device"*.
 */
export const runDeviceMarks: RunDeviceMarks = ({ geometry, circuitId }) =>
  (geometry?.byCircuit[circuitId]?.paths ?? []).flatMap((path) => {
    const end = path.waypoints[path.waypoints.length - 1];
    return end ? [{ x: end.x, y: end.y }] : [];
  });
